// MarketingServices.js
import React from 'react';
import { Field, ErrorMessage } from 'formik';

const MarketingServices = () => {
  return (
    <div className="h-100">
      <div className="row h-100 align-items-center">
        <div className="col-12 col-xs-12 col-md-12 px-0">
          <div className="general-info-form py-5">
            <div className="row">
              <div className="col-12 p-0">
                <p className="llc-text mb-2">
                  Are you interested in managed marketing services from Rentid?
                </p>
                <p className="llc-desc mb-4">
                  We can assist with your digital marketing efforts.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-xs-12 col-md-6 p-0 pe-md-2">
                <div className="form-check ps-0">
                  <Field
                    type="radio"
                    id="marketingServicesYes"
                    name="marketing_services"
                    value="Yes"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label form-check-field w-100"
                    htmlFor="marketingServicesYes"
                  >
                    <div className="row">
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-10 ps-0">
                            <img
                              src="/img/beta-signup/target.svg"
                              className="img-fluid"
                              alt="Yes, manage marketing"
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12 ps-0">
                            <p className="llc-heading mb-0">Yes</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-12 col-xs-12 col-md-6 mt-3 mt-md-0 p-0 ps-md-2">
                <div className="form-check ps-0">
                  <Field
                    type="radio"
                    id="marketingServicesNo"
                    name="marketing_services"
                    value="Happy with my current marketing"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label form-check-field w-100"
                    htmlFor="marketingServicesNo"
                  >
                    <div className="row">
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-10 ps-0">
                            <img
                              src="/img/beta-signup/shaking-hands.svg"
                              className="img-fluid"
                              alt="Happy with my current marketing"
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12 p-0">
                            <p className="llc-heading mb-0">
                              Happy with my current marketing 
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <ErrorMessage name="marketing_services" component="div" className="invalid-feedback" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingServices;
